<div class="calendar-container">
    <div class="calendar-header">
        <button mat-icon-button (click)="navigate(-1)"
            matTooltip="Previous Month"><mat-icon>arrow_back_ios</mat-icon></button>
        <button mat-button [matMenuTriggerFor]="monthYearMenu" matTooltip="Select month and year">
            {{ currentMonth | date: 'MMMM yyyy' }}
            <mat-icon>expand_more</mat-icon>
        </button>
        <mat-menu #monthYearMenu="matMenu">
            <div style="padding: 20px;" (mousedown)="$event.stopPropagation()">
                <mat-form-field appearance="outline" class="full-width" (click)="$event.stopPropagation()"
                    (focus)="$event.stopPropagation()">
                    <mat-label>Month</mat-label>
                    <mat-select [(ngModel)]="selectedMonth" required (click)="$event.stopPropagation()">
                        <mat-option *ngFor="let month of months; let i = index" [value]="i">{{ month }}</mat-option>
                    </mat-select>
                </mat-form-field>

                <mat-form-field appearance="outline" class="full-width" (click)="$event.stopPropagation()"
                    (focus)="$event.stopPropagation()">
                    <mat-label>Year</mat-label>
                    <input matInput type="number" [(ngModel)]="selectedYear" required
                        (click)="$event.stopPropagation()">
                </mat-form-field>

                <button mat-button (click)="onMonthYearChange()">Set</button>
            </div>
        </mat-menu>
        <button mat-icon-button (click)="navigate(1)"
            matTooltip="Next Month"><mat-icon>arrow_forward_ios</mat-icon></button>
    </div>
    <div class="calendar-grid">
        <div class="day-name" *ngFor="let dayName of dayNames">{{ dayName }}</div>
        <ng-container *ngFor="let day of days; let dayIndex = index">
            <div class="day" [ngClass]="{'today': isToday(day.date), 'unavailable': !isAvailable(day.date), 'selected': selectedDay && day.date && selectedDay.getTime() === day.date.getTime()}"
                (click)="selectDay(day)">
                <span class="day-number">{{ day.date | date: 'd' }}</span>



                <div *ngIf="getPublicHolidayDetails(day.date) as holidayDetails" class="blocked-message holiday"
                    [matTooltip]="holidayDetails?.name">
                    <span class="blocked-reason">{{ holidayDetails?.name }}</span>
                </div>

                <div class="appointment-counters">
                    <div *ngFor="let count of day.appointmentCounts" class="appointment-count-circle"
                        [matTooltip]="count.type"
                        [ngStyle]="{'background-color': count.backgroundColor,'color': count.textColor, 'border': count.borderColor ? '2px solid ' + count.borderColor : '' }">
                        {{ count.count }}
                    </div>
                </div>

                <!-- Financial summary for the day -->
                <div class="day-financial-summary"
                    *ngIf="getFinancialSummaryForDate(day.date, true).totalInvoiced !== 0 || getFinancialSummaryForDate(day.date, true).totalPaid !== 0 || getFinancialSummaryForDate(day.date, true).totalOutstanding !== 0">
                    <div class="day-financial-amount invoice-amount">
                        <span class="label">Inv:</span> {{ getFinancialSummaryForDate(day.date, true).totalInvoiced | currency:'ZAR':'R':'1.0-0' }}
                    </div>
                    <div class="day-financial-amount paid-amount">
                        <span class="label">Paid:</span> {{ getFinancialSummaryForDate(day.date, true).totalPaid | currency:'ZAR':'R':'1.0-0' }}
                    </div>
                    <div class="day-financial-amount outstanding-amount">
                        <span class="label">Outs:</span> {{ getFinancialSummaryForDate(day.date, true).totalOutstanding | currency:'ZAR':'R':'1.0-0' }}
                    </div>
                </div>
                
                <!-- Appointment invoice summary for the day -->
                <div class="day-financial-summary" *ngIf="getAppointmentsForDate(day.date).length > 0">
                    <div class="day-financial-amount appointment-count-amount">
                        <span class="label">Apps:</span> {{ getInvoicedAppointmentsForDate(day.date) }} of {{ getTotalAppointmentsForDate(day.date) }} invoiced
                    </div>
                </div>
                <!-- Estimate row -->
                <div class="day-financial-summary" *ngIf="getEstimateTotalForDate(day.date) > 0">
                    <div class="day-financial-amount estimate-amount" style="color: #2196f3;">
                        <span class="label">Est.:</span> {{ getEstimateTotalForDate(day.date) | currency:'ZAR':'R':'1.0-0' }}
                    </div>
                </div>

                <!-- Connect claims summary for the day -->
                <div class="day-financial-summary connect-day-summary"
                    *ngIf="getConnectDayForDate(day.date) as connectDay">
                    <span class="connect-day-label">Connect</span>
                    <div class="day-financial-amount connect-claimed-amount">
                        <span class="label">Clm:</span> {{ connectDay.claimed }}
                    </div>
                    <div class="day-financial-amount paid-amount">
                        <span class="label">Paid:</span> {{ connectDay.paid }}
                    </div>
                </div>

            </div>

        </ng-container>

        <!-- Conditionally render the expanded row -->
        <div *ngIf="selectedDay && appointmentsForSelectedDay && startOfWeekIndex !== null" class="appointments-for-day"
            [style.gridRowStart]="getAppointmentRowStart()" [style.gridColumn]="getAppointmentColumnSpan()"
            [@rowAnimation]="'active'">
            <div class="row-header">
                <div class="header-content">
                    <!-- Financial Summary Heading -->
                    <h3 class="unlinked-heading">Financial Summary for {{ selectedDay | date: 'fullDate' }}</h3>
                    <!-- Financial Summary (restored old block) -->
                    <div *ngIf="getBillingDocumentsForSelectedDay().length > 0" class="financial-summary">
                        <div class="financial-summary-item">
                            <span class="label">Invoiced:</span>
                            <span class="amount">{{ getFinancialSummaryForSelectedDay().totalInvoiced |
                                currency:'ZAR':'R' }}</span>
                        </div>
                        <div class="financial-summary-item">
                            <span class="label">Paid:</span>
                            <span class="amount paid">{{ getFinancialSummaryForSelectedDay().totalPaid |
                                currency:'ZAR':'R' }}</span>
                        </div>
                        <div class="financial-summary-item">
                            <span class="label">Outstanding:</span>
                            <span class="amount outstanding">{{ getFinancialSummaryForSelectedDay().totalOutstanding |
                                currency:'ZAR':'R' }}</span>
                        </div>
                        <!-- Vertical Separator -->
                        <div *ngIf="getFinancialSummaryForSelectedDay().totalPaid > 0" class="vertical-separator"></div>
                        <!-- Payment Method Breakdown -->
                        <div *ngIf="getFinancialSummaryForSelectedDay().totalPaid > 0" class="payment-breakdown">
                            <div class="payment-breakdown-items">
                                <div class="payment-breakdown-item"
                                    *ngIf="getFinancialSummaryForSelectedDay().cashAmount > 0">
                                    <span class="label">Cash:</span>
                                    <span class="amount cash">{{ getFinancialSummaryForSelectedDay().cashAmount |
                                        currency:'ZAR':'R' }}</span>
                                </div>
                                <div class="payment-breakdown-item"
                                    *ngIf="getFinancialSummaryForSelectedDay().electronicAmount > 0">
                                    <span class="label">Electronic:</span>
                                    <span class="amount electronic">{{
                                        getFinancialSummaryForSelectedDay().electronicAmount | currency:'ZAR':'R'
                                        }}</span>
                                </div>
                                <div class="payment-breakdown-item"
                                    *ngIf="getFinancialSummaryForSelectedDay().creditedAmount > 0">
                                    <span class="label">Credited:</span>
                                    <span class="amount credited">{{ getFinancialSummaryForSelectedDay().creditedAmount
                                        | currency:'ZAR':'R' }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- Connect claims summary for the selected day -->
                    <div *ngIf="connectSummaryForSelectedDay as connectSummary" class="connect-claims-summary">
                        <h3 class="unlinked-heading connect-claims-heading">Connect Claims
                            <span class="connect-code-count">({{ connectSummary.day.codeCount }}
                                {{ connectSummary.day.codeCount === 1 ? 'code' : 'codes' }})</span>
                        </h3>
                        <div class="financial-summary">
                            <div class="financial-summary-item">
                                <span class="label">Claimed:</span>
                                <span class="amount">{{ connectSummary.claimed }}</span>
                            </div>
                            <div class="financial-summary-item">
                                <span class="label">Approved:</span>
                                <span class="amount approved">{{ connectSummary.approved }}</span>
                            </div>
                            <div class="financial-summary-item">
                                <span class="label">Rejected:</span>
                                <span class="amount rejected">{{ connectSummary.rejected }}</span>
                            </div>
                            <div class="financial-summary-item">
                                <span class="label">Patient Liable:</span>
                                <span class="amount patient-liable">{{ connectSummary.patientLiable }}</span>
                            </div>
                            <div class="financial-summary-item">
                                <span class="label">Paid:</span>
                                <span class="amount paid">{{ connectSummary.paid }}</span>
                            </div>
                            <div class="financial-summary-item">
                                <span class="label">Outstanding:</span>
                                <span class="amount outstanding">{{ connectSummary.outstanding }}</span>
                            </div>
                            <div class="financial-summary-item" *ngIf="connectSummary.day.clawbackCents !== 0">
                                <span class="label">Clawback:</span>
                                <span class="amount clawback">{{ connectSummary.clawback }}</span>
                            </div>
                        </div>
                    </div>
                    <!-- Unified Appointments and Financial Documents -->
                    <mat-list class="full-width">
                        <mat-list-item *ngFor="let appointment of appointmentsForSelectedDay" class="auto-height">
                            <div class="appointment-item stack-mobile">
                                <div class="appointment-details">
                                    <div class="appointment-time">
                                        <ng-container>
                                            {{ (appointment.date.substring(0,10) + 'T' + appointment.timeSlot) | date:
                                            'HH:mm'}}{{appointment.endSlot ? ' - ' + appointment.endSlot : ''}}
                                        </ng-container>
                                        <span class="appointment-type" [matTooltip]="appointment.typeDetails.type"
                                            [ngStyle]="{'background-color': appointment.typeDetails.backgroundColor,'color': appointment.typeDetails.textColor, 'border': appointment.typeDetails.borderColor ? '2px solid ' + appointment.typeDetails.borderColor : '' }">
                                        </span>
                                        {{ appointment.appointmentType }}{{appointment.virtualLink ? ' (Virtual)' : ''}}
                                    </div>
                                    <ng-container *ngIf="appointment.Patient">
                                        <span class="patient-name">{{ appointment.Patient.surname }}, {{
                                            appointment.Patient.name }}</span>
                                        <span class="patient-number" *ngIf="appointment.Patient.patientNumber">({{
                                            appointment.Patient.patientNumber }}) </span>
                                        <span class="patient-diagnosis">{{ appointment.Patient.diagnosis }}</span>
                                        <div matLine *ngIf="appointment.Patient.diagnosis2" class="patient-procedure">
                                            <span>{{ buildDiagnosisString(appointment.Patient) }}</span>
                                        </div>
                                        <span class="patient-procedure" *ngIf="appointment.procedure">Procedure: {{
                                            appointment.procedure }}</span>
                                        <span class="patient-procedure" *ngIf="appointment.reasonForVisit">{{
                                            appointment.reasonForVisit }}</span>
                                    </ng-container>
                                    <ng-container *ngIf="appointment.reason">
                                        <span class="patient-name">{{ appointment.reason }}</span>
                                    </ng-container>
                                </div>
                               
                                <div class="actions">
                                    <button mat-icon-button (click)="toggleFinancialDocs(appointment)"
                                        [attr.aria-label]="isFinancialDocsExpanded(appointment) ? 'Collapse financial info' : 'Expand financial info'">
                                        <mat-icon>{{ isFinancialDocsExpanded(appointment) ? 'expand_less' :
                                            'expand_more' }}</mat-icon>
                                    </button>
                                    <mat-chip
                                        [ngClass]="getDocumentStatusChipClass(getAppointmentFinancialStatus(appointment))">
                                        {{ getAppointmentStatusLabel(getAppointmentFinancialStatus(appointment)) }}
                                    </mat-chip>
                                    <button *ngIf="appointment.Patient" mat-icon-button matTooltip="View Patient"
                                        (click)="navigateToPatientFile(appointment.Patient.id)">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                </div>
                            </div>
                            
                            <!-- Appointment Status Indicator -->
                            <div *ngIf="!appointment.reason" class="appointment-status" 
                                [matTooltip]="getAppointmentCancellationTooltip(appointment)"
                                [class.cancelled]="appointment.isCancelled === true"
                                [class.did-not-attend]="appointment.didNotAttend === true">
                            </div>
                            <!-- Linked Financial Documents -->
                            <div class="linked-financial-docs"
                                *ngIf="getBillingDocumentsForAppointment(appointment.id).length > 0 && isFinancialDocsExpanded(appointment)">
                                <mat-list dense>
                                    <mat-list-item
                                        *ngFor="let doc of getSortedBillingDocumentsForAppointment(appointment.id)"
                                        class="financial-document-item">
                                        <div class="financial-document-content">
                                            <div class="document-header">
                                                <span class="document-type">{{ doc.documentType | titlecase }} </span>
                                                <mat-chip [ngClass]="getDocumentStatusChipClassForDocument(doc)">{{
                                                    getDocumentStatusLabel(doc) }}</mat-chip>
                                            </div>
                                            <div class="document-details">
                                                <ng-container *ngIf="doc.documentType === 'invoice'">
                                                    <span class="document-amount">Total: {{ doc.totalDue |
                                                        currency:'ZAR':'R' }}</span>
                                                    <span *ngIf="doc.amountPaid > 0" class="document-paid">Paid: {{
                                                        doc.amountPaid | currency:'ZAR':'R' }}</span>
                                                    <span *ngIf="doc.outstandingBalance > 0"
                                                        class="document-outstanding">Outstanding: {{
                                                        doc.outstandingBalance | currency:'ZAR':'R' }}</span>
                                                </ng-container>
                                                <ng-container *ngIf="doc.documentType === 'receipt'">
                                                    <span class="document-amount">Received: {{ doc.subtotal |
                                                        currency:'ZAR':'R' }}</span>
                                                    <span *ngIf="doc.PatientPayment" class="document-payment-method">via
                                                        {{ doc.PatientPayment.paymentMethod }}</span>
                                                </ng-container>
                                                <ng-container *ngIf="doc.documentType === 'estimate'">
                                                    <span class="document-amount">Estimated: {{ doc.totalDue |
                                                        currency:'ZAR':'R' }}</span>
                                                </ng-container>
                                            </div>
                                        </div>
                                    </mat-list-item>
                                </mat-list>
                            </div>
                            <!-- Connect claim roll-up for this appointment's patient on this day.
                                 Matched by (patientId, service date) only — a patient with two
                                 appointments the same day shows the same connect row on both. -->
                            <div class="connect-appointment-row"
                                *ngIf="isFinancialDocsExpanded(appointment) && getConnectSummaryForAppointment(appointment) as connectRow">
                                <span class="connect-day-label">Connect</span>
                                <span *ngIf="connectRow.awaitingResponse" class="connect-awaiting-chip">Awaiting
                                    response</span>
                                <ng-container *ngIf="!connectRow.awaitingResponse">
                                    <span class="connect-claimed">Claimed: {{ connectRow.claimed }}</span>
                                    <span class="connect-paid">Paid: {{ connectRow.paid }}</span>
                                    <span class="connect-outstanding">Outstanding: {{ connectRow.outstanding }}</span>
                                </ng-container>
                            </div>
                        </mat-list-item>
                    </mat-list>

                    <!-- Unlinked Financial Documents Section -->
                    <div *ngIf="getUnlinkedFinancialDocumentsGroupedByPatient().length > 0"
                        class="unlinked-financial-docs-section">
                        <div class="unlinked-heading-row"
                            style="display: flex; align-items: center; justify-content: space-between; cursor: pointer;"
                            (click)="unlinkedDocsExpanded = !unlinkedDocsExpanded">
                            <h3 class="unlinked-heading" style="margin: 0;">Unlinked Financial Documents</h3>
                            <mat-icon>{{ unlinkedDocsExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </div>
                        <ng-container *ngIf="unlinkedDocsExpanded">
                            <ng-container *ngFor="let group of getUnlinkedFinancialDocumentsGroupedByPatient()">
                                <div class="unlinked-patient-group">
                                    <div class="unlinked-patient-header"
                                        style="display: flex; align-items: center; cursor: pointer;"
                                        (click)="toggleUnlinkedPatientGroup(group.patientId)">
                                        <mat-icon>{{ isUnlinkedPatientGroupExpanded(group.patientId) ? 'expand_less' :
                                            'expand_more' }}</mat-icon>
                                        <span style="margin-right: 8px;">{{ group.patientName }}</span>
                                        <button *ngIf="group.patientId !== 'unknown'" mat-icon-button
                                            matTooltip="View Patient"
                                            (click)="$event.stopPropagation(); navigateToPatientFile(group.patientId)">
                                            <mat-icon>visibility</mat-icon>
                                        </button>
                                    </div>
                                    <div class="unlinked-patient-docs"
                                        *ngIf="isUnlinkedPatientGroupExpanded(group.patientId)">
                                        <mat-list dense>
                                            <mat-list-item *ngFor="let doc of group.documents"
                                                class="financial-document-item">
                                                <div class="financial-document-content">
                                                    <div class="document-header">
                                                        <span class="document-type">{{ doc.documentType | titlecase
                                                            }}</span>
                                                        <mat-chip
                                                            [ngClass]="getDocumentStatusChipClassForDocument(doc)">{{
                                                            getDocumentStatusLabel(doc) }}</mat-chip>
                                                    </div>
                                                    <div class="document-details">
                                                        <ng-container *ngIf="doc.documentType === 'invoice'">
                                                            <span class="document-amount">Total: {{ doc.totalDue |
                                                                currency:'ZAR':'R' }}</span>
                                                            <span *ngIf="doc.amountPaid > 0" class="document-paid">Paid:
                                                                {{ doc.amountPaid | currency:'ZAR':'R' }}</span>
                                                            <span *ngIf="doc.outstandingBalance > 0"
                                                                class="document-outstanding">Outstanding: {{
                                                                doc.outstandingBalance | currency:'ZAR':'R' }}</span>
                                                        </ng-container>
                                                        <ng-container *ngIf="doc.documentType === 'receipt'">
                                                            <span class="document-amount">Received: {{ doc.subtotal |
                                                                currency:'ZAR':'R' }}</span>
                                                            <span *ngIf="doc.PatientPayment"
                                                                class="document-payment-method">via {{
                                                                doc.PatientPayment.paymentMethod }}</span>
                                                        </ng-container>
                                                        <ng-container *ngIf="doc.documentType === 'estimate'">
                                                            <span class="document-amount">Estimated: {{ doc.totalDue |
                                                                currency:'ZAR':'R' }}</span>
                                                        </ng-container>
                                                    </div>
                                                </div>
                                            </mat-list-item>
                                        </mat-list>
                                    </div>
                                </div>
                            </ng-container>
                        </ng-container>
                    </div>

                    <!-- Connect claims for patients without an appointment on this day
                         (echoes the unlinked financial documents section) -->
                    <div *ngIf="getConnectClaimsWithoutAppointment().length > 0"
                        class="unlinked-financial-docs-section connect-no-appointment-section">
                        <div class="unlinked-heading-row"
                            style="display: flex; align-items: center; justify-content: space-between; cursor: pointer;"
                            (click)="connectNoAppointmentExpanded = !connectNoAppointmentExpanded">
                            <h3 class="unlinked-heading" style="margin: 0;">Connect Claims (No Appointment)</h3>
                            <mat-icon>{{ connectNoAppointmentExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
                        </div>
                        <ng-container *ngIf="connectNoAppointmentExpanded">
                            <div class="unlinked-patient-group"
                                *ngFor="let connectRow of getConnectClaimsWithoutAppointment()">
                                <div class="unlinked-patient-header" style="display: flex; align-items: center;">
                                    <span style="margin-right: 8px;">{{ connectRow.day.patientName }}</span>
                                    <button mat-icon-button matTooltip="View Patient"
                                        (click)="navigateToPatientFile(connectRow.day.patientId)">
                                        <mat-icon>visibility</mat-icon>
                                    </button>
                                </div>
                                <div class="connect-appointment-row">
                                    <span class="connect-day-label">Connect</span>
                                    <span *ngIf="connectRow.awaitingResponse" class="connect-awaiting-chip">Awaiting
                                        response</span>
                                    <ng-container *ngIf="!connectRow.awaitingResponse">
                                        <span class="connect-claimed">Claimed: {{ connectRow.claimed }}</span>
                                        <span class="connect-paid">Paid: {{ connectRow.paid }}</span>
                                    </ng-container>
                                </div>
                            </div>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="mobile-spacer"></div>
</div>

<ng-template #noResults>
    <p class="no-records-message">No appointments found.</p>
</ng-template>